// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import xProductPartNumbersStyles from "@guestsupply/App/SharedStyles/ProductPartNumbersStyles";
import { productPartNumbersStyles } from "@guestsupply/Overrides/Components/ProductPartNumbers";
import ShippingWeight from "@guestsupply/XDL/Icons/ShippingWeight";
import { css } from "styled-components";

productPartNumbersStyles.container = {
    gap: 0,
    offsetCss: css`
        gap: 1px;
    `,
};
productPartNumbersStyles.erpNumberLabelText = {
    ...xProductPartNumbersStyles.label,
};
productPartNumbersStyles.erpNumberValueText = {
    ...xProductPartNumbersStyles.value,
};
productPartNumbersStyles.customerNameLabelText = {
    ...xProductPartNumbersStyles.label,
};
productPartNumbersStyles.customerNameValueText = {
    ...xProductPartNumbersStyles.value,
};
productPartNumbersStyles.manufacturerItemLabelText = {
    ...xProductPartNumbersStyles.label,
};
productPartNumbersStyles.manufacturerItemValueText = {
    ...xProductPartNumbersStyles.value,
};
productPartNumbersStyles.trackingNumberLabelText = {
    ...xProductPartNumbersStyles.label,
};
productPartNumbersStyles.trackingNumberValueText = {
    ...xProductPartNumbersStyles.value,
};
productPartNumbersStyles.shippingWeightLabelText = {
    ...xProductPartNumbersStyles.label,
};
productPartNumbersStyles.shippingWeightValueText = {
    ...xProductPartNumbersStyles.value,
};
productPartNumbersStyles.shippingWeightWrapper = {
    ...cartLineSharedStyles.shippingWeightWrapper,
};
productPartNumbersStyles.icon = {
    src: ShippingWeight,
    width: 16,
    height: 14,
};
productPartNumbersStyles.shippingWeightGridItem = {
    css: css`
        align-items: baseline;
    `,
};

productPartNumbersStyles.casePackGridItem = {
    css: css`
        &&& {
            align-items: baseline;
            margin-top: 3px;
        }
    `,
};
